<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-content>
          <!-- 卡片主体(表单) -->
          <div class="md-layout card-form" style="max-width: 1200px;">
            <!-- 选择查询类型 -->
            <div class="md-layout-item md-size-20 left-layout-item md-xsmall-size-50">
              <md-field>
                <md-select v-model="searchForm.searchType" >
                  <md-option value="1">{{$I18n('dev_snid')}}</md-option>
                  <md-option value="2">{{$I18n('user_id')}}</md-option>
                </md-select>
              </md-field>
            </div>
            <!-- 查询的值 -->
            <div class="md-layout-item md-size-20 left-layout-item md-xsmall-size-50">
              <md-field>
                <label>{{searchName}}</label>
                <md-input v-model="searchForm.searchValue"/>
              </md-field>
            </div>
            <div class="md-layout-item md-size-20 left-layout-item md-xsmall-size-50">
              <md-field>
                <label>{{$I18n("state")}}</label>
                <md-select v-model="searchForm.state" >
                  <md-option value="0">{{$I18n('all')}}</md-option>
                  <md-option value="1">{{$I18n('un_overdue')}}</md-option>
                  <md-option value="2">{{$I18n('is_outfo_date')}}</md-option>
                  <!-- <md-option value="3">{{$I18n('un_use')}}</md-option> -->
                </md-select>
              </md-field>
            </div>
            <!-- 查询 (date) -->
            <div class="md-layout-item md-size-20 left-layout-item md-xsmall-size-50">
              <md-field class="md-theme-default md-has-value">
                <!-- <label>{{$I18n("create_time")}}</label> -->
                <el-date-picker
                  class="md-date-form-item"
                  align="left"
                  v-model="searchForm.create_time"
                  type="daterange"
                  prefixIcon="no"
                  range-separator="~"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :picker-options="pickerOptions"
                  :start-placeholder="$I18n('start')"
                  :end-placeholder="$I18n('end')">
                </el-date-picker>
              </md-field>
            </div>
            <div class="md-layout-item md-size-20 md-xsmall-size-50">
              <md-button class= "left-icon md-info" @click="form_changeSearchData">
                <md-icon>search</md-icon>
                {{$I18n("search")}}
              </md-button>
            </div>
          </div>
        </md-card-content>
      </md-card>
      <md-card>
        <!-- 卡片主体(表格) -->
        <md-card-content>
          <div class="md-layout ">
            <div class="md-layout-item right-layout-item">
              <md-button class="left-icon md-info" @click="form_importModel">
                {{$I18n("import_and_update")}}
              </md-button>
              <md-button class="left-icon md-info" @click="form_importTableModel">
                {{$I18n("dev_import")}}
              </md-button>
            </div>
          </div>
          <md-table v-model="tableData">
            <md-table-row slot="md-table-row" slot-scope="{ item }" >
              <md-table-cell :md-label="$I18n('type')">{{ item.type_name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('user_id')">{{ item.user_id }}</md-table-cell>
              <md-table-cell :md-label="$I18n('dev_snid')">{{ item.uid }}</md-table-cell>
              <md-table-cell :md-label="$I18n('state')">{{ item.state_name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('start_time')">{{ item.iotid_start_time }}</md-table-cell>
              <md-table-cell :md-label="$I18n('end_time')">{{ item.iotid_end_time }}</md-table-cell>
              <md-table-cell :md-label="$I18n('latest_timestamp')">{{ item.iotid_update_time }}</md-table-cell>
            </md-table-row>
            <md-table-empty-state slot="md-table-empty-state">
              {{$I18n("none_data")}}
            </md-table-empty-state>
          </md-table>
        </md-card-content>
        <!-- 卡片-表格-翻页 -->
        <table-page :total="total" :pageSize="pageSize" v-model="currentPage"/>
      </md-card>
    </div>
    <!-- 弹窗 -->
    <simple-modal 
      ref    = "modal"
      :title = "modalTitle"
      :large = "openModalType==='import'"
      :right = "openModalType!=='delete'"
      :submitBtn="openModalType !=='import'"
      @submit= "modal_submit"
    >
      <template slot="body">
        <!-- 导入文件表格弹窗 -->
        <div v-if="openModalType==='import'">
          <div class="md-layout">
            <!-- 导入状态 -->
            <div class="md-layout-item md-size-25 left-layout-item">
              <md-field>
                <label>{{$I18n("import_state")}}</label>
                <md-select 
                  id="type"
                  name="type"
                  v-model="modalSearchData.state" 
                 :placeholder="$I18n('flie_dev')"
                >
                  <md-option :value="0">{{$I18n("all")}}</md-option>
                  <md-option :value="1">{{$I18n("import_succ")}}</md-option>
                  <md-option :value="2">{{$I18n("import_fail")}}</md-option>
                  <md-option :value="4">{{$I18n("is_sync_database")}}</md-option>
                </md-select>
              </md-field>
            </div>
            <!-- 导入时间 -->
            <div class="md-layout-item md-size-30 left-layout-item">
              <md-field class="md-theme-default md-has-value">
                <label>{{$I18n("import_time")}}</label>
                <el-date-picker
                  class="md-date-form-item"
                  align="left"
                  v-model="modalSearchData.time"
                  type="daterange"
                  range-separator="~"
                  prefixIcon="no"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :picker-options="pickerOptions"
                  :start-placeholder="$I18n('start')"
                  :end-placeholder="$I18n('end')">
                </el-date-picker>
              </md-field>
            </div>
            <div class="md-layout-item left-btn">
              <md-button class= "left-icon md-info" @click="modal_changeSearchData">
                <md-icon>search</md-icon>
                {{$I18n("search")}}
              </md-button>
            </div>
          </div>
          <md-table v-model="modalTableData" class="left-table">
            <md-table-row slot="md-table-row" slot-scope="{item}">
              <md-table-cell :md-label="$I18n('import_id')">{{ item.id }}</md-table-cell>
              <md-table-cell :md-label="$I18n('user_id')">{{ item.user_id }}</md-table-cell>
              <md-table-cell :md-label="$I18n('start_time')">{{ item.start_time_date }}</md-table-cell>
              <md-table-cell :md-label="$I18n('end_time')">{{ item.end_time_date }}</md-table-cell>
              <md-table-cell :md-label="$I18n('type')">{{ item.type_name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('import_file')+'/UID' " >
                <span v-if="item.link_type == 2">{{item.link_id}}</span>
                <a
                  v-if="item.link_type == 1 && item.link_id" 
                  :style='{color:"blue", cursor: "pointer"}'
                  :download="`import-${item.import_id}.xlsx`" 
                  :href="item.link_id" 
                >
                  <!-- {{`import-${item.import_id}.xlsx`}} -->
                  {{`xlsx`}}
                </a>
                <span v-if="item.link_type == 1 && !item.link_id">{{$I18n("is_none")}}</span>
              </md-table-cell>
              <md-table-cell 
                :md-label="`${$I18n('mng_num')}/${$I18n('succ_num')}/${$I18n('fail_num')}`"
              >
                {{item.mng_num}}/
                <span :style='{color:"green"}'>{{item.succ_num}}</span>/
                <span :style='{color:"red"}'>{{item.fail_num}}</span>
              </md-table-cell>
              <md-table-cell :md-label="$I18n('import_state')">
                {{item.state_name}}
                <!-- <span v-if="item.state == 1" :style="{color:'green'}">
                  {{$I18n("has_sync_database")}}
                </span>
                <span v-else-if="!item.state" :style="{color:'red'}">
                  {{$I18n("wait_sync_database")}}
                </span>
                <span v-else-if="item.state == 2 || item.state == 3" :style="{color:'red'}">
                  {{$I18n("has_error_row")}}
                </span> -->
              </md-table-cell>

              <md-table-cell :md-label="$I18n('import_date')">{{ item.create_time }}</md-table-cell>
              <md-table-cell :md-label="$I18n('update_time')">{{ item.update_time }}</md-table-cell>
            </md-table-row>
            <md-table-empty-state slot="md-table-empty-state">
              {{$I18n("none_data")}}
            </md-table-empty-state>
          </md-table>
          <!-- 卡片-表格-翻页 -->
          <table-page :total="import_total" :pageSize="import_pageSize" v-model="import_currentPage"/>
        </div>
        <!-- 修改/添加弹窗 -->
        <div v-else>
          <!-- 选择文件 -->
          <modal-form-item :label='$I18n("type")' class="">
            <md-field >
              <md-select v-model="modalData.state" :placeholder="$I18n('pls_input_role_id')">
                <md-option :value="1">{{$I18n("file")}}</md-option>
                <md-option :value="2">{{"UID"}}</md-option>
              </md-select>
            </md-field>
          </modal-form-item>
          <!-- 创建时间 (date) -->
          <modal-form-item :label='$I18n("effect_time")'>
            <md-field class="md-theme-default md-has-value">
              <el-date-picker
                class="md-date-form-item modal-date"
                v-model="modalData.create_time"
                type="daterange"
                ref="inputDate"
                prefixIcon="no"
                range-separator=""
                value-format="yyyy-MM-dd HH:mm:ss"
                :clearable="false">
              </el-date-picker>
              <md-input 
                readonly
                :placeholder="$I18n('pls_input')" 
                v-model = "modal_create_time"
                @click="modal_date"
              ></md-input>
            </md-field>
          </modal-form-item>
          <!-- 选择文件 -->
          <modal-form-item v-if="modalData.state == 1" :label='$I18n("select_file") ' :required="true">
            <md-field :class="{'md-error' : error.file}">
              <md-input 
                readonly
                @click="modal_file_input"
                :placeholder="$I18n('click_select_file')" 
                v-model="modalData.file" />
              <md-icon v-if="error.file">clear</md-icon>
              <input :style="{display:'none'}" type="file" ref="inputFile" @change="onChange"/>
            </md-field>
          </modal-form-item>
          <modal-form-item v-if="modalData.state == 2" :label='"UID"' class="">
            <md-field >
              <md-input v-model="modalData.file" :placeholder="$I18n('pls_input')" />
            </md-field>
          </modal-form-item>
        </div>
      </template>
      <template slot="footer-btn" v-if="openModalType !=='import'">
        <a :download="`${$I18n('frame')}.xlsx`" href="/files/iot_update.xlsx" style="position: absolute;left: 0;top: 10px;">
          <md-button :style="{ 'left': '32px', 'position': 'absolute'}" class="left-icon md-info">
            {{$I18n("frame")}}
          </md-button>
        </a>
      </template>
    </simple-modal>
  </div>
</template>
<script>
import { nDaysAgo, timestampToString } from "@/common/tools.js";
export default {
  props: ["userinfo_sys"],
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      modalSearchData : {
        file_dev_type : "2",
        time:"",
        state: "0",
      },
      searchForm : {
        searchType : "1",
        searchValue: "",
        state : "0",
        create_time:[],
      },
      searchData : {
        mac : "",
        uid : "",
        state: 0,
      },
      // 表格相关
      icon  : "computer",
      title : this.$I18n("cloud_service_platform"),
      tableInitData : [], // 表格数据
      compData : [], // 公司数据
      // 分页相关
      pageSize : 10,
      currentPage : 1,
      total : 0,
      // 弹窗相关
      openModal: false,  // 是否打开弹窗
      openModalType : "upload", // 弹窗类型
      modalTitle : "",  // 弹窗标题
      // 弹窗表单相关
      modalData : {
        state : "1",
        create_time:[nDaysAgo(7)+ " 00:00:00", nDaysAgo(0)+ " 23:59:59"],
        file : "",
        file_url : "",
      },
      // 弹窗表单报错相关
      error: {
        file : false,
      },
      // 弹窗表格数据
      modalTableInitData : [],
      import_currentPage : 1,
      import_pageSize : 10,
      import_total : 0,
    };
  },
  mounted : function() {
    this.api_getPageData();
  },
  watch: {
    '$root.state':{
      handler(){
        return 
      },
      immediate: true,
      deep: true,
    },
    currentPage() {
      this.api_getPageData();
    },
  },
  computed: {
    searchName(){
      switch(this.searchForm.searchType){
        case "1":
          return this.$I18n("dev_snid");
        case "2":
          return this.$I18n("user_id");
        case "3":
          return this.$I18n("app_id");
        default:
          return this.$I18n("unknow")
      }
    },
    modalTableForm(){
      return {
        state     : this.modalSearchData.state,
        gmt_start : this.modalSearchData.time && this.modalSearchData.time[0] ? new Date(this.modalSearchData.time[0]).getTime() / 1000 :"",
        gmt_end   : this.modalSearchData.time && this.modalSearchData.time[1] ? new Date(this.modalSearchData.time[1]).getTime() / 1000 :"", 
        // file_dev_type    : this.modalSearchData.file_dev_type,
        // import_start_time: this.modalSearchData.time ?this.modalSearchData.time[0] :"",
        // import_end_time  : this.modalSearchData.time ?this.modalSearchData.time[1] :"",
        // page_no   : this.import_currentPage,
        // page_size : this.import_pageSize,
      }
    },
    //
    modalTableData () {
      if (!this.modalTableInitData || this.modalTableInitData.length === 0){
        return [];
      } else {
        return [...this.modalTableInitData]
          .splice((this.import_currentPage-1) * this.import_pageSize, this.import_pageSize)
          .map(item => {
            // let type_name = "";
            // console.log(item)
            // switch(parseInt(item.type)){
            //   case 1: 
            //     type_name = this.$I18n("is_useing");
            //     break;
            //   case 2: 
            //     type_name = this.$I18n("is_outfo_date");
            //     break;
            //   default : 
            //     type_name = this.$I18n("unknow");
            //     break;
            // }
            let state_name = "";
            switch(parseInt(item.state)){
              case 1: 
                state_name = this.$I18n("import_succ");
                break;
              case 2: 
                state_name = this.$I18n("import_fail");
                break;
              case 4: 
                state_name = this.$I18n("is_sync_database");
                break;
              // case 3: 
              //   state_name = this.$I18n("has_error_row");
              //   break;
              default : 
                state_name = ""//this.$I18n("is_sync_database");
                break;
            }
            return {
              type_name : item.link_type == 1 ?this.$I18n("file") :"UID",
              state_name,
              mng_num: item.mng_num ?item.mng_num :0,
              succ_num: item.succ_num ?item.succ_num :0,
              fail_num: item.fail_num ?item.fail_num :0,
              start_time_date : item.gmt_start ? nDaysAgo(0, item.gmt_start * 1000) : "",
              end_time_date   : item.gmt_end   ? nDaysAgo(0, item.gmt_end * 1000)   : "",
              create_time : item.gmt_create    ? nDaysAgo(0, item.gmt_create * 1000) : "",
              update_time : item.gmt_update    ? timestampToString(item.gmt_update * 1000)   : "",
              ... item,
            }
          })
      }
    },
    // 表格数据
    tableData(){
      if (!this.tableInitData || this.tableInitData.length === 0){
        return [];
      } else {
        return [...this.tableInitData].map(item => {
          let type_name = ""
          switch(parseInt(item.iotid_type)){
            case 1: 
              type_name = this.$I18n("user_buy");
              break;
            case 2: 
              type_name = this.$I18n("company_import");
              break;
            default : 
              type_name = this.$I18n("unknow");
              break;
          }
          let state_name = "";
          switch(parseInt(item.iotid_order_state)){
            case 1: 
              state_name = this.$I18n("is_useing");
              break;
            case 2: 
              state_name = this.$I18n("overdue");
              break;
            case 3: 
              state_name = this.$I18n("un_use");
              break;
            default : 
              state_name = this.$I18n("unknow");
              break;
          }
          return {
            type_name,
            state_name,
            update_time: timestampToString(item.gmt_update * 1000),
            ... item,
          }
        })
      }
    },
    modal_create_time:{
      get(){
        if(!this.modalData.create_time){
          return "";
        }
        return this.modalData.create_time
          .map(item => {
            return item.split(" ")[0];
          }) 
          .join(" ~ ")
      },
      set(){},
    },
    
  },
  methods: {
    // 更改查询条件(并立刻查询)
    form_changeSearchData(){
      this.searchData = {
        state      : this.searchForm.state, 
        sys        : this.userinfo_sys,
        uid        : "",
        user_id    : "",
        app_id     : "",
        start_time : this.searchForm.create_time && this.searchForm.create_time[0] ?this.searchForm.create_time[0] :"",
        end_time   : this.searchForm.create_time && this.searchForm.create_time[1] ?this.searchForm.create_time[1].replace("00:00:00", "23:59:59") :"",
      }
      switch(this.searchForm.searchType){
        case "1":
          this.searchData.uid = this.searchForm.searchValue;
          break;
        case "2":
          this.searchData.user_id = this.searchForm.searchValue;
          break;
        case "3":
          this.searchData.app_id = this.searchForm.searchValue;
          break;
      }
      this.currentPage = 1;
      this.api_getPageData();
    },
    modal_changeSearchData(){
      this.api_getXlsxData();
    },
    //点击上传文件
    modal_file_input(){
      this.$refs.inputFile.click()
    },
    modal_date(){
      this.$refs.inputDate.focus();
    },
    // (file发生变化)
    onChange ($event) {
      this.onFileSelected($event)
    },
    onFileSelected ({ target, dataTransfer }) {
      const files = target.files || dataTransfer.files;

      this.modalData.file = this.getFileName(files, target);
    },
    getFileName (files, target) {
      if (!files || files.length === 0) {
        return target.value.split('\\').pop()
      }

      if (files.length > 1) {
        return this.getMultipleName(files)
      }

      if (files.length === 1) {
        var formData = new FormData();
        formData.append('myfile', files[0]);
        this.$api.uploadFile(formData)
          .then(this.$Then(res => {
            this.modalData.file_url = res.data
          }))
          .catch(this.$Catch(""))
        return files[0].name
      }
      return null
    },
    // 获取页面信息
    api_getPageData(){
      // 获取角色
      this.$api.getIotOrder({
          ...this.searchData,
          page_size: this.pageSize,
          page_no: this.currentPage,
      })
        .then(this.$Then(res => {
          this.tableInitData = res.data;
          this.total = res.count;
        }))
        .catch(this.$Catch(this.$I18n("get_error"), () => {
          this.tableInitData = [];
          this.total = 0;
        }))
    },
    // 打开 导入xlsx弹窗
    form_importModel () {
      this.openModalType = "update";
      this.modalTitle = this.$I18n("import_and_update");
      this.modalData = {
        state : "1",
        sys : this.userinfo_sys,
        create_time:[nDaysAgo(7)+ " 00:00:00", nDaysAgo(0)+ " 23:59:59"],
        file : "",
        file_url : "",
      };
      this.$refs.modal.open();
    },
    form_importTableModel () {
      this.api_getXlsxData();
      this.openModalType = "import";
      this.modalTitle = this.$I18n("dev_import");
      this.$refs.modal.open();
    },
    // 隐藏 弹窗
    modal_classicModalHide () {
      this.openModal = false;
      this.error.file = false;
    },
    // 提交表单
    modal_submit () {
      if(!this.modalData.file_url && !this.modalData.file){
        this.error.file = true;
        this.$errorMsg(this.$I18n("pls_check_verify"));
        return 
      }
      this.$api.uploadIotOrder({
          sys: this.userinfo_sys,
          link_id: this.modalData.state == 1 ? this.modalData.file_url :this.modalData.file,
          link_type: this.modalData.state,
          gmt_start: new Date(this.modalData.create_time[0]).getTime() / 1000,
          gmt_end: new Date(this.modalData.create_time[1].replace("00:00:00", "23:59:59")).getTime() / 1000,
      })
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("oper_succ"));
          this.modal_classicModalHide();
          this.$refs.modal.close();
        }))
        .catch(this.$Catch(""))
    },
    // 
    api_getXlsxData (){
      this.$api.getIotOrderXlsx(this.modalTableForm)
        .then(this.$Then(resData => {
          this.modalTableInitData = resData.data;
          this.import_total = resData.count;
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.modalTableInitData = [];
          this.import_total = 0;
        }))
    },
  },
}
</script>
<style lang="scss" scoped>
  .left-btn {
    text-align:left;
  }
  .modal-date.md-date-form-item{
    width: 0;
    overflow: hidden;
    margin: 0;
    padding: 0;
  }
  .md-date-form-item {
    height : 36px;
    border : none;
  }
  .left-table{
    margin-top: 16px;
    text-align: left;
  }
  .card-form {
    margin-top: 12px;
  }
  // 左侧表单对齐表格
  .left-layout-item{
    padding-rigth:8px;
    padding-left:8px;
  }
  // 表单右侧对齐表格
  .right-layout-item{
    text-align: right;
    padding:0;
  }

  // 表单里的单选框
  .radio-layout{
    margin-top: 6px;
  }
  // 弹窗
  .lg-modal .modal-container{
    width : 80%;
    max-width: unset;
  }
  // 表格的ID列
  .numbers {
    width: 160px;
  }
  // 表格的按钮列
  .button-box {
    width: 120px;
  }
  //左侧iocn
  .left-icon{
    margin-left: 16px;
  }
  // flaot 右的按钮
  .right-button {
    float:right;
  }

  .text-right .md-table-cell-container {
    display: flex;
    justify-content: flex-end;
  }
  .md-table .md-table-head:last-child {
    text-align: right;
  }

  .table-stats {
    display: flex;
    align-items: center;
    text-align: right;
    flex-flow: row wrap;

    .td-price .td-total {
      display: inline-flex;
      font-weight: 500;
      font-size: 1.0625rem;
      margin-right: 50px;
    }

    &.table-striped .td-price {
      border-bottom: 0;
    }

    .td-price {
      font-size: 26px;
      border-top: 1px solid #ddd;
      border-bottom: 1px solid #ddd;
    }

    .td-price,
    > div {
      flex: 0 0 100%;
      padding: 12px 8px;
    }
  }
</style>
